import type { TrackingEvent } from '@owc/connection-aem-tracking';
import type { TrackEvent } from '../types/analytics-type';
import { CONNECTIONS } from '../types/enums';
import { getConnectionDispatchers } from './seamless';

/**
 * Trigger the dispatch on analytics connection to add event to the queue.
 *
 * @param  {TrackEvent}    trackEvent Event descriptor
 * @return {Promise<void>}
 */
export async function dispatchAnalytics(trackEvent: TrackEvent): Promise<void> {
  const dispatcher = await getConnectionDispatchers(CONNECTIONS.TRACKING_CONNECTION_NAME);

  const {
    action = '',
    event = 'click',
    category = 'link',
    label = 'default',
    type = '',
    URL = undefined,
    version = '',
    id = 'B2X',
    name = '',
  } = trackEvent;

  const trackVersion = type && version ? `${type}-${version}` : '';

  const trackingEvent: TrackingEvent = {
    event,
    eventDetail: {
      category,
      action,
      label,
      URL,
      name,
    },
    application: {
      id,
      version: trackVersion,
      parentApplicationId: 'aem',
    },
  };

  if (dispatcher) {
    return dispatcher.pushTrackingEvent?.(trackingEvent);
  }
}
